import $ from 'jquery';
import '@accessible360/accessible-slick';

declare global {
	interface JQuery {
		slick(options?: any): JQuery;
	}
}

document.addEventListener('DOMContentLoaded', () => {
    const $carousel = $('.logo-carousel .logos');

    const slickSettings = {
        arrows: false,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: true,
        centerPadding: 0,
        cssEase: 'linear',
        dots: false,
        draggable: false,
        fade: false,
        infinite: true,
        pauseOnHover: false,
        slidesToShow: 5,
        variableWidth: true,
        slidesToScroll: 1,
        speed: 4500,
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 800,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    $carousel.slick(slickSettings);

    // Reinitialize the carousel on window resize
    let resizeTimeout: number | undefined;
    $(window).on('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = window.setTimeout(() => {
            if ($carousel.hasClass('slick-initialized')) {
                $carousel.slick('unslick');
            }
            $carousel.slick(slickSettings);
        }, 200);
    });
});